export enum ProductUseFunction {
	STARTED = "start",
	CARTITEM = "cartitem",
	TRANSACTIONCOMPLETE = "transactioncomplete",
}
